import { darken } from './utils';

export function circleScale(o) {
  const cs = ['interpolate', ['linear'], ['zoom']];
  o.scale.forEach((s) => {
    cs.push(s[0]);
    cs.push(['+', o.min, ['*', s[1], ['sqrt', ['number', ['get', o.key], 0]]]]);
  });
  return cs;
}

export function circleScaleFunction(o) {
  return function (val, z) {
    const v = Math.sqrt(val);
    let iz = o.scale.length;
    for (let i = o.scale.length - 1; i >= 0; i--) {
      if (z <= o.scale[i][0]) iz = i;
    }
    let f = 0;
    if (iz === 0) {
      f = o.scale[0][1];
    } else if (iz === o.scale.length) {
      f = o.scale[o.scale.length - 1][1];
    } else {
      f = (z - o.scale[iz - 1][0]) / (o.scale[iz][0] - o.scale[iz - 1][0])
          * (o.scale[iz][1] - o.scale[iz - 1][1]) + o.scale[iz - 1][1];
    }
    window.iz = iz;
    return 2 * (o.min + f * v);
  };
}


export function circleCurrentKeyColors(key, values, colors, colorDeactivated) {
  const expr = [
    'match',
    ['get', key],
    ...values.map((item, i) => [item,
      ['case',
        ['boolean', ['feature-state', 'notActive'], false], colorDeactivated,
        ['boolean', ['feature-state', 'current'], false],
        darken(colors[i], 0.6), colors[i]]]).flat(), // colorDeactivated,
    /* other */ '#ccc',
  ];
  return expr;
}

export function circleColors(key, values, colors, defaultColor) {
  const expr = [
    'match',
    ['get', key],
    ...values.map((item, i) => [item,
      ['case',
        ['boolean', ['feature-state', 'current'], false],
        darken(colors[i], 0.6), colors[i]]]).flat(), // colorDeactivated,
    ['case',
      ['boolean', ['feature-state', 'current'], false],
      darken(defaultColor, 0.6), defaultColor],
  ];
  return expr;
}

export function circleCurrent(yes, no) {
  return ['case', ['boolean', ['feature-state', 'current'], false], yes, no];
}

export function circleActive(yes, no) {
  return ['case', ['boolean', ['feature-state', 'active'], false], yes, no];
}

export function switchMapCallback(switchKey, dataKey, colorDict, nonActiveColor, map) {
  return function callback(arg) {
    const ons = [];

    arg.forEach((item) => {
      ons.push(item[switchKey]);
    });
    if (ons.length > 0) {
      map.map.setPaintProperty(
        'points', 'circle-color',
        circleColors(
          dataKey,
          ons,
          ons.map(el => colorDict[el]),
          nonActiveColor,
        ),
      );
    } else {
      map.map.setPaintProperty(
        'points', 'circle-color',
        circleCurrent(darken(nonActiveColor, 0.6), nonActiveColor),
      );
    }
  };
}

/* eslint-disable */
export function patchMapboxOpenmaptilesLanguages() {
  var langFallbackDecorate = function(style, cfg) {
    var layers = style.layers;
    var lf = cfg['layer-filter'];
    var decorators = cfg['decorators'];
    var lfProp = lf[1];
    var lfValues = lf.slice(2);

    for (var i = layers.length-1; i >= 0; i--) {
      var layer = layers[i];
      if(!(
          lf[0]==='in'
          && lfProp==='layout.text-field'
          && layer.layout && layer.layout['text-field']
          && lfValues.indexOf(layer.layout['text-field'])>=0
      )) {
        continue;
      }
      for (var j = decorators.length-1; j >= 0; j--) {
        var decorator = decorators[j];
        var postfix = decorator['layer-name-postfix'] || '';
        postfix = postfix.replace(/(^-+|-+$)/g, '');

        if(j>0) {
          var newLayer = JSON.parse(JSON.stringify(layer));
          layers.splice(i+1, 0, newLayer);
        } else {
          newLayer = layer;
        }
        newLayer.id += postfix ? '-'+postfix : '';
        newLayer.layout['text-field'] = decorator['layout.text-field'];
        if(newLayer.layout['symbol-placement']==='line') {
          newLayer.layout['text-field'] =
              newLayer.layout['text-field'].replace('\n', ' ');
        }
        var filterPart = decorator['filter-all-part'].concat();
        if(!newLayer.filter) {
          newLayer.filter = filterPart;
        } else if(newLayer.filter[0]=='all') {
          newLayer.filter.push(filterPart);
        } else {
          newLayer.filter = [
            'all',
            newLayer.filter,
            filterPart
          ];
        }
      }
    }
  };

  var origSetStyle = mapboxgl.Map.prototype.setStyle;
  mapboxgl.Map.prototype.setStyle = function() {
    origSetStyle.apply(this, arguments);

    if (!this.setStyleMutex) {
      if (this.styleUndecorated) {
        this.styleUndecorated = undefined;
      }
      this.once('styledata', function() {
        if (this.languageOptions) {
          this.setLanguage(
            this.languageOptions.language,
            this.languageOptions.noAlt
          );
        }
      }.bind(this));
    }
  };

  mapboxgl.Map.prototype.setLanguage = function(language, noAlt) {
    this.languageOptions = {
      language: language,
      noAlt: noAlt
    };
    if (!this.styleUndecorated) {
      try {
        this.styleUndecorated = this.getStyle();
      } catch (e) {}
    }
    if (!this.styleUndecorated) {
      return;
    }

    var isNonlatin = [
      'ar', 'hy', 'be', 'bg', 'zh', 'ka', 'el', 'he',
      'ja', 'ja_kana', 'kn', 'kk', 'ko', 'mk', 'ru', 'sr',
      'th', 'uk'
    ].indexOf(language) >= 0;

    var style = JSON.parse(JSON.stringify(this.styleUndecorated));
    var langCfg = {
      "layer-filter": [
        "in",
        "layout.text-field",
        "{name}",
        "{name_de}",
        "{name_en}",
        "{name:latin}",
        "{name:latin} {name:nonlatin}",
        "{name:latin}\n{name:nonlatin}"
      ],
      "decorators": [
        {
          "layout.text-field": isNonlatin ? ("{name:nonlatin}" + (noAlt ? "" : "\n{name:latin}")) : ("{name:latin}" + (noAlt ? "" : "\n{name:nonlatin}")),
          "filter-all-part": [
            "!has",
            "name:" + language
          ]
        },
        {
          "layer-name-postfix": language,
          "layout.text-field": "{name:" + language + "}" + (noAlt ? "" : "\n{name:" + (isNonlatin ? 'latin' : 'nonlatin') + "}"),
          "filter-all-part": [
            "has",
            "name:" + language
          ]
        }
      ]
    };
    if (language == 'native') {
      langCfg['decorators'] = [
        {
          "layout.text-field": "{name}",
          "filter-all-part": ["all"]
        }
      ];
    }
    langFallbackDecorate(style, langCfg);

    this.setStyleMutex = true;
    this.setStyle(style);
    this.setStyleMutex = false;
  };

  mapboxgl.Map.prototype.autodetectLanguage = function(opt_fallback) {
    this.setLanguage(navigator.language.split('-')[0] || opt_fallback || 'native');
  };
}
